import styled from '@emotion/styled'

import { TYPOGRAPHY_15_12 } from 'theme/theme'

const Button = styled.button`
  ${TYPOGRAPHY_15_12}

  min-width: ${props => props.minW ? props.minW : '100px'};
  max-width: ${props => props.maxW ? props.maxW : '200px'};
  min-height: 34px;
  border-radius: 5px;
  background-color: ${props => props.primary ? '#0bf' : '#fff'};
  color: ${props => props.primary ? '#fff !important' : '#0bf !important'};
  border: ${props => props.primary ? '0' : '1px solid #efeff2'};
  cursor: pointer;
  text-align: center;
  margin-right: 20px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &:first-of-type {
    margin-left: 0;
  }

  &:last-of-type {
    margin-right: 0;
  }

  @media (max-width: 525px) {
    flex: 1;
    min-width: 100px;
    margin-bottom: 10px;
  }
`

export default Button

export const MultiButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 20px;

  @media (max-width: 810px) {
    justify-content: center;
  }
`
